import { useEffect, useState } from 'react';
import axios from 'axios';
import MainURL from '../MainURL';

interface GalleryItem {
  id: number;
  image: string;
  subtitle: string;
  date: string;
}

interface GalleryGridProps {
  endpoint: string;   // 예: /main/getgalleryprogram
  emptyText: string;
}

// 갤러리 목록 + 클릭 시 상세보기
export default function GalleryGrid({ endpoint, emptyText }: GalleryGridProps) {

  const [items, setItems] = useState<GalleryItem[]>([]);
  const [selected, setSelected] = useState<GalleryItem | null>(null);

  const fetchPosts = async () => {
    try {
      const res = await axios.get(`${MainURL}${endpoint}`);
      setItems(res.data && Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error('갤러리 조회 오류:', error);
      setItems([]);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, [endpoint]);

  // 상세보기 열려있을 때 ESC로 닫기
  useEffect(() => {
    if (!selected) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setSelected(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selected]);

  return (
    <>
      <div className="program-box">
        {
          items.length > 0
          ?
          items.map((item, index) => (
            <div className="program-content" key={item.id || index} onClick={() => setSelected(item)}>
              <div className="program-content-imagebox">
                <div className="program-content-image">
                  <img src={`${MainURL}/images/gallery/${item.image}`} alt={item.subtitle || '갤러리 사진'}/>
                </div>
              </div>
              <div className="program-content-textbox">
                <div className="program-content-programName">{item.subtitle}</div>
                <div className="program-content-notice">{item.date}</div>
              </div>
            </div>
          ))
          :
          <div style={{textAlign: 'center', padding: '50px', color: '#999'}}>
            {emptyText}
          </div>
        }
      </div>

      {selected && (
        <div className="gallery-detail-overlay" onClick={() => setSelected(null)}>
          <div className="gallery-detail" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="gallery-detail-close" aria-label="닫기" onClick={() => setSelected(null)}>×</button>
            <div className="gallery-detail-image">
              <img src={`${MainURL}/images/gallery/${selected.image}`} alt={selected.subtitle || '갤러리 사진'}/>
            </div>
            {(selected.subtitle || selected.date) && (
              <div className="gallery-detail-text">
                {selected.subtitle && <h3>{selected.subtitle}</h3>}
                {selected.date && <p>{selected.date}</p>}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
